var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTutorialBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-Icons-/-Question-(Error:-Missing-Answer)",
    transform: "translate(-2.000000, -2.000000)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C5.83488372,0 0,5.83488372 0,13 C0,20.1651163 5.83488372,26 13,26 C20.1651163,26 26,20.1651163 26,13 C26,5.83488372 20.1651163,0 13,0 Z M13,24.1860465 C6.83255814,24.1860465 1.81395349,19.1674419 1.81395349,13 C1.81395349,6.83255814 6.83255814,1.81395349 13,1.81395349 C19.1674419,1.81395349 24.1860465,6.83255814 24.1860465,13 C24.1860465,19.1674419 19.1674419,24.1860465 13,24.1860465 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.496071,6 C10.7723434,6 9.36754771,7.2219095 9.01789804,8.74568776 C8.93517459,9.08832718 9.14861262,9.48191312 9.46422997,9.56863202 C9.77980614,9.65535093 10.139297,9.41922178 10.2159057,9.07487891 C10.4036702,8.25666396 11.3336603,7.34482666 12.496071,7.34482666 C13.0687116,7.34482666 13.6696816,7.57367133 14.0934283,7.94719693 C14.5171955,8.32072254 14.7633071,8.80172221 14.7633071,9.36206665 C14.7633071,10.0979782 14.6253043,10.4283125 14.4412456,10.6858692 C14.2572075,10.9434483 13.9623019,11.143693 13.5781464,11.4423342 C13.1940115,11.7409978 12.7367884,12.153353 12.405874,12.8222025 C12.0750008,13.4910521 11.884148,14.3865049 11.884148,15.6379334 C11.8521128,16.0093969 12.1565095,16.3732846 12.4992622,16.3732846 C12.8420354,16.3732846 13.1464321,16.0093969 13.1143969,15.6379334 C13.1143969,14.5359151 13.2847644,13.8834501 13.4944142,13.4595831 C13.7040845,13.0357834 13.9629608,12.8037112 14.2995369,12.5420303 C14.6361131,12.2803495 15.0637921,12.0112721 15.420277,11.5123772 C15.7767826,11.0134914 16,10.3071884 16,9.36206665 C16,8.35344665 15.5232799,7.48262656 14.8663717,6.9035442 C14.2094223,6.32448426 13.3632466,6 12.496071,6 L12.496071,6 Z",
    id: "Path",
    stroke: "#FFF",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5024533,18.2068978 C12.0471244,18.2068978 11.6780188,18.6083061 11.6780188,19.1034489 C11.6780188,19.5985917 12.0471244,20 12.5024533,20 C12.9577617,20 13.3269084,19.5985917 13.3269084,19.1034489 C13.3269084,18.6083061 12.9577617,18.2068978 12.5024533,18.2068978 Z",
    id: "Path",
    stroke: "#FFF",
    strokeWidth: 0.7
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialBtn);
export default __webpack_public_path__ + "static/media/icon_tutorial_btn.66f1c1cc.svg";
export { ForwardRef as ReactComponent };